export default {"src":"/_next/static/media/btnBack.4555b6cc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};